<template>
  <div class="refund-list bgf6 h100">
    <van-pull-refresh class="h100" v-model="refreshing" @refresh="onRefresh">
      <div class="refund-content">
        <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad">
          <div v-for="(item, index) in list" :key="index">
            <div class="list-item">
              <div class="icm-title">
                <div class="prefix-icon"><img class="icon-img" src="../../static/images/refund/icon_ks.png" alt="" srcset=""></div>
                <div class="label-content">{{item.batchName}}</div>
              </div>
              <div class="icm-content">
                <div class="content-left">{{item.specialtyName}}({{item.gradeName}})</div>
                <div class="content-right">
                  ¥{{Number(item.refundFee || 0).toFixed(2)}}
                </div>
              </div>
              <div class="icm-divider">
                <div class="divider-line"></div>
                <div class="ellipse left"></div>
                <div class="ellipse right"></div>
              </div>
              <div class="icm-datetime">
                <div class="datatime-left">
                  订单日期：{{$moment(item.addTime).format('YYYY.MM.DD HH:mm')}}
                </div>
                <div :class="{'datatime-right': true, 'no-active': item.auditStatus !== 2 ? false: true}">
                  <img v-if="item.auditStatus !== 2" class="prefix-icon" src="../../static/images/refund/icon_tkz.png" alt="" srcset="">
                  <img v-else class="prefix-icon" src="../../static/images/refund/icon_tk.png" alt="" srcset="">
                  <span class="suffix-label">{{item.auditStatus === 2 ? '已退款' : '退款中'}}</span>
                </div>
              </div>
              <div class="icm-operation">
                <van-button class="button" v-if="item.auditStatus !== 2" plain type="primary" @click="handleClick(1, item)">撤销申请</van-button>
                <van-button class="button" v-if="item.auditStatus !== 2" plain type="info" style="margin-left: 0.32rem" @click="handleClick(2, item)">修改申请</van-button>
                <van-button class="button" v-if="item.auditStatus === 2" type="primary" @click="handleClick(3, item)">退款详情</van-button>
              </div>
            </div>
          </div>
        </van-list>
        <van-empty class="empty" v-if="!list.length && finished" :image="require('../../static/images/express/yjkong@2x.png')" description="暂无退款信息..."/>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Picker, Popup, Icon, PullRefresh, List, Empty, Button, Dialog, Toast } from 'vant'
import refundData from '../../mock/refund'

export default {
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
    [Button.name]: Button
  },
  data () {
    return {
      finishedText: '正在加载中...',
      loading: false,
      finished: false,
      refreshing: false,
      list: []
    }
  },
  created () {

  },
  methods: {
    async onLoad () {
      await this.getList()
    },
    onRefresh () {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.onLoad()
    },
    // 获取数据
    async getList () {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      try {
        this.loading = true
        let { data: list } = (await this.$HTTP.ApiRefund.listRefundGet()) || { data: [] }
        list = list || []
        list.map(item => {
          item.isOpen = false
          return item
        })
        this.list = list
        this.loading = false
        this.finished = true
        this.finishedText = this.list.length ? '没有更多内容了...' : ''
      } catch (error) {
        this.loading = false
        this.finished = true
        this.finishedText = '网络异常，请下拉刷新'
      }
    },

    // 按钮事件点击 type{1: 撤销申请， 2: 修改申请， 3: 退款详情}
    handleClick (type, item) {
      switch (type) {
        case 1:
          // 
          Dialog.confirm({
            title: '撤销退款',
            message: '是否确认撤销退款申请？',
          }).then(() => {
            // on confirm
            this.cancelRefund(item)
          })
          .catch(() => {
            // on cancel
          });
          break
        case 2:
          this.$router.push({
            path: '/refund/refund-edit',
            query: {
              type: item.auditStatus === 3 ? 1 : 2,
              orderId: item.examOrderId
            }
          })
          break
        case 3:
          this.$router.push({
            path: '/refund/refund-detail',
            query: {
              orderId: item.examOrderId
            }
          })
          break
      }
    },

    // 撤销退款
    async cancelRefund (item) {
      await this.$HTTP.ApiRefund.cancelRefundGet(item.refundOrderId)
      Toast('撤销成功')
      this.onLoad()
    }
  }
}
</script>
<style lang="less" scoped>
  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
    opacity: 0
  }
  .empty {
    margin-top: 200px/2;
  }
  .refund-content {
    width: 100%;
    height: 100%;
    padding: 20px 20px 60px 20px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    overflow-y: auto;
  }

  .list-item {
    position: relative;
    margin: 0px 0 48px/2 0;
    padding: 32px/2 32px/2;
    background: #FFFFFF;
    border-radius: 10px/2;
  }

  .icm-title {
    display: flex;
    font-size: 28px/2;
    color: #77573A;
    margin: 10px/2 0;
    line-height: 40px/2;
    font-family: 'SourceHanSerifCN-Regular';

    .prefix-icon {
      margin-right: 8px/2;
      .icon-img {
        width: 32px/2;
        vertical-align: middle;
      }
    }
    .label-content {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 60px/2;
    }
  }

  .icm-content {
    display: flex;
    margin: 16px/2 0;
    justify-content: space-between;
    line-height: 58px/2;
    color: #260E09;
    font-weight: bold;
    font-size: 40px/2;
    font-family: 'SourceHanSerifCN-Bold';
  }

  .icm-divider {
    margin: 20px/2 0;
    height: 40px/2;
    position: relative;
    line-height: 40px/2;
    .divider-line {
      display: inline-block;
      width: 100%;
      vertical-align: middle;
      border-top: 2px dashed #D6CDC9;
    }
    .ellipse {
      display: inline-block;
      position: absolute;
      top: 0;
      width: 40px/2;
      height: 40px/2;
      border-radius: 50%;
      background-color: #F6F6F6;

      &.left {
        left: -55px/2;
      }
      &.right {
        right: -55px/2;
      }
    }
  }

  .icm-datetime {
    display: flex;
    justify-content: space-between;
    line-height: 50px/2;
    color: #908581;
    font-size: 24px/2;
    .datatime-left {
      vertical-align: middle;
    }
    .datatime-right {
      .prefix-icon {
        width: 24px/2;
        vertical-align: middle;
      }
      .suffix-label {
        margin-left: 5px/2;
        vertical-align: middle;
        color: #BC3019;
      }

      &.no-active {
        .suffix-label {
          color: #B8A9A2;
        }
      }
    }
  }
  .icm-operation {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px/2;

    button {
      height: 56px/2;
    }
  }

  .button {
    margin-top: 32px/2;
  }

</style>